// extracted by mini-css-extract-plugin
var _1 = "CustomerTransferDetails-module__form-action-button-disabled";
var _2 = "CustomerTransferDetails-module__loader";
var _3 = "CustomerTransferDetails-module__subcontainer";
export { _1 as "form-action-button-disabled", _2 as "loader", _3 as "subcontainer" }
